import * as TemplateModels from './models'
import * as TemplateSelectors from './selector'
import * as TemplateActions from './actions/index.actions'

export { TemplateModels, TemplateSelectors, TemplateActions }
